import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { useSnackbar } from "notistack";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import {
  Paper,
  Button,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Chip,
  Typography,
  Modal,
  TextField,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import Grid from "@mui/system/Unstable_Grid/Grid";
import jMoment from "moment-jalaali";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ReceiptDetailsDoctors = () => {
  const auth = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();

  const [receiptInfo, setReceiptInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isPaid, setIsPaid] = useState(false);

  const receiptId = useParams().rId;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const getReceiptInfo = async () => {
    await axios
      .post(
        "/api/v1/doctors/get-receipt-details",
        { receiptId },
        { headers: { Authorization: auth.token } }
      )
      .then((res) => setReceiptInfo(res.data.data))
      .catch(
        (err) =>
          err.data &&
          err.data.map((error) => {
            enqueueSnackbar(error, { variant: "error" });
          })
      );
    setIsLoading(false);
  };
  useEffect(() => {
    if (receiptInfo) setIsPaid(receiptInfo.isPayed);
  }, [receiptInfo]);

  const handleConfirmPayment = async () => {
    await axios
      .post(
        "/api/v1/doctors/update-receipt-payment",
        {
          receiptId: receiptInfo.id,
          status: true,
        },
        { headers: { Authorization: auth.token } }
      )
      .then(() => {
        setIsPaid(true);
        handleClose();
      })
      .catch(
        (err) =>
          err.data &&
          err.data.map((error) => {
            enqueueSnackbar(error, { variant: "error" });
          })
      );
  };

  useEffect(() => {
    getReceiptInfo();
  }, [receiptId]);

  const prevRoute = useSelector((state) => state.routeReducer.prevRoute);

  if (isLoading) {
    return (
      <div className="center">
        <h2>در حال بارگذاری...</h2>
      </div>
    );
  }

  return (
    <Paper sx={{ flexGrow: 1, maxWidth: 1200 }}>
      <div>
        <Modal open={open} onClose={handleClose}>
          <Box sx={style}>
            <Typography variant="h6" component="h2">
              هشدار
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              آیا مطمئن هستید که این فاکتور پرداخت شده است؟
            </Typography>
            <Grid container spacing={3} sx={{ mt: 2 }}>
              <Grid xs={6}>
                <Button
                  fullWidth
                  color="primary"
                  variant="contained"
                  onClick={handleClose}
                >
                  خیر
                </Button>
              </Grid>
              <Grid xs={6}>
                <Button
                  fullWidth
                  color="success"
                  variant="contained"
                  onClick={handleConfirmPayment}
                >
                  بله
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>

      <Box
        sx={{
          // flexGrow: 1,
          maxWidth: 1200,
          p: 2,
          m: 1,
          gap: 4,
          display: "flex",
          flexDirection: "column",
        }}
        elevation={2}
      >
        <Grid
          container
          justifyContent={"space-between"}
          alignItems={"center"}
          spacing={3}
        >
          <Grid
            sm={6}
            xs={12}
            display={"flex"}
            justifyContent={{ sm: "flex-start", xs: "center" }}
          >
            <Typography variant="h5" align="center">
              اطلاعات فاکتور
            </Typography>
          </Grid>
          <Grid
            sm={6}
            xs={12}
            display={"flex"}
            justifyContent={{ sm: "flex-end", xs: "center" }}
          >
            <Chip
              label={isPaid ? "پرداخت شده" : "پرداخت نشده"}
              color={isPaid ? "success" : "error"}
              sx={{
                py: 3,
                px: 3,
                width: { xs: "100%", sm: "fit-content" },
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid md={6} xs={12}>
            <TextField
              variant="standard"
              label="شناسه فاکتور"
              value={receiptInfo.id}
              inputProps={{ readOnly: true }}
              fullWidth
            />
          </Grid>
          <Grid md={6} xs={12}>
            <TextField
              variant="standard"
              label="تاریخ صدور"
              value={jMoment(parseInt(receiptInfo.submissionDate)).format(
                "jYY/jMM/jDD "
              )}
              inputProps={{ readOnly: true }}
              fullWidth
            />
          </Grid>
          <Grid md={6} xs={12}>
            <TextField
              variant="standard"
              label="به نام"
              value={receiptInfo.name}
              inputProps={{ readOnly: true }}
              fullWidth
            />
          </Grid>
          <Grid md={6} xs={12}>
            <TextField
              variant="standard"
              label="ارسال شده برای"
              value={receiptInfo.doctor.name}
              inputProps={{ readOnly: true }}
              fullWidth
            />
          </Grid>
          <Grid xs={12}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="justify">نام پزشک</TableCell>
                    <TableCell align="justify">نام بیمار</TableCell>
                    <TableCell align="justify">نوع کار</TableCell>
                    <TableCell align="justify">تعداد واحد</TableCell>
                    <TableCell align="justify">قیمت هر واحد</TableCell>
                    <TableCell align="justify">مبلغ سفارش</TableCell>
                    <TableCell align="justify">مبلغ پس از تخفیف</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {receiptInfo.orders.map((receipt) => (
                    <React.Fragment>
                      <TableRow>
                        <TableCell align="justify">
                          {receipt.doctorName}
                        </TableCell>
                        <TableCell align="justify">
                          {receipt.patientName}
                        </TableCell>
                        <TableCell align="justify">
                          {receipt.orderTypeName}
                        </TableCell>
                        <TableCell align="justify">
                          {receipt.unitCount}
                        </TableCell>
                        <TableCell align="justify">
                          {receipt.unitCost}
                        </TableCell>
                        <TableCell align="justify">
                          {receipt.totalCost}
                        </TableCell>
                        <TableCell align="justify">
                          {receipt.afterDiscount}
                        </TableCell>
                      </TableRow>
                      {receipt.attachments.map((attachment) => (
                        <TableRow>
                          <TableCell>
                            <Chip label="پیوست" color="primary" size="small" />
                          </TableCell>
                          <TableCell>---</TableCell>
                          <TableCell align="justify">
                            {attachment.title}
                          </TableCell>
                          <TableCell align="justify">
                            {attachment.count}
                          </TableCell>
                          <TableCell>---</TableCell>
                          {/* <TableCell children="---" /> */}
                          <TableCell align="justify">
                            {attachment.totalPrice}
                          </TableCell>
                          <TableCell align="justify">
                            {attachment.afterDiscount}
                          </TableCell>
                        </TableRow>
                      ))}
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid xs={12} md={4}>
            <Button
              fullWidth
              color="success"
              variant="outlined"
              onClick={handleOpen}
              disabled={isPaid}
            >
              <CheckIcon />
            </Button>
          </Grid>
          <Grid xs={12} md={4}>
            <Button fullWidth color="secondary" variant="contained">
              <FileDownloadIcon />
            </Button>
          </Grid>
          <Grid xs={12} md={4}>
            <Link
              to={prevRoute}
              style={{
                color: "inherit",
                textDecoration: "inherit",
              }}
            >
              <Button fullWidth color="primary" variant="contained">
                <ArrowBackIcon />
              </Button>
            </Link>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default ReceiptDetailsDoctors;
